const generateUniqueKey = (pre: string | number) => `${pre}_${new Date().getTime()}_${Math.floor(100000 + Math.random() * 900000)}`;

export default generateUniqueKey;
